"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { cleanProps, cn } from "../../utils/index.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { HorizonIcon } from "../HorizonIcon/index.js";
import { IconButton } from "../IconButton/index.js";
import { inputChipVariants } from "./InputChip.variants.js";
function InputChip({ label, className, onCloseButtonClick, id, name, value, disabled, size = 'sm', iconLeft, customIcon, emphasis, ...props }) {
    const handleCloseButtonClick = ()=>{
        onCloseButtonClick?.();
    };
    const { labelTextSlot, containerSlot, iconLeftSlot, iconRightSlot, checkboxSlot } = inputChipVariants({
        ...props,
        disabled,
        size,
        emphasis
    });
    const classes = cn(containerSlot(), className);
    return /*#__PURE__*/ jsxs("div", {
        className: classes,
        ...cleanProps(props, [
            'selected',
            'type',
            'elevated',
            'emphasis'
        ]),
        tabIndex: disabled ? void 0 : 0,
        children: [
            iconLeft && !customIcon && /*#__PURE__*/ jsx(CdnIcon, {
                className: iconLeftSlot(),
                iconName: iconLeft,
                size: '18'
            }),
            customIcon && /*#__PURE__*/ jsx(HorizonIcon, {
                className: iconLeftSlot(),
                name: customIcon,
                size: '18'
            }),
            /*#__PURE__*/ jsx("span", {
                className: labelTextSlot(),
                children: label
            }),
            /*#__PURE__*/ jsx(IconButton, {
                className: iconRightSlot(),
                onClick: handleCloseButtonClick,
                iconName: "close",
                size: "2xs",
                type: "plainSecondary",
                disabled: disabled,
                emphasis: emphasis
            }),
            /*#__PURE__*/ jsx("input", {
                className: checkboxSlot(),
                type: "checkbox",
                id: id,
                name: name,
                "data-testid": id,
                disabled: disabled,
                checked: true,
                readOnly: true,
                value: value,
                tabIndex: -1
            })
        ]
    });
}
export { InputChip };
